export const allPartnersCompanyGroupCode = "ALL_PARTNERS";
export const removeConfirmationWord = "DELETE";
export const archiveConfirmationWord = "ARCHIVE";
export const downloadMimeType = "application/octet-stream";
export const whistleBlowSystemUserCode = "SYSTEM";
export const minimumPasswordLength = 8;
export const maximumPasswordLength = 30;
export const totalTaskDataRowId = "totalRow";
//Risk
export const residualRiskLevelThreshold = 10;
//UserParameterCodes
export const userParameterShowPageNavigation = "ShowPageNavigation";
//OptionCode
export const optionCodeTaskTypeExpressionInfoDocument = "TaskTypeExpressionInfoDocument";
export const optionCodeRiskMatrixInfoDocument = "RiskMatrixInfoDocument";
//Mobile
export const infiniteListPageSize = 30;
export const infiniteListPageHalfSize = 15;
//Colors
export const stateLightGray = "#dcdcdc";
export const stateGray = "#ada7a7";
export const stateBlue = "#579bfc";
export const stateRed = "#E2445C";
export const stateOrange = "#fdab3d";
export const stateYellow = "#eae54d";
export const stateGreen = "#00c875";
